<template>
  <GamAttendeeRow
    v-if="rowPlayer"
    class="attendee-row"
    :player="rowPlayer"
    :is-organizer="isOrganizer"
    :is-confirmed="isConfirmed"
    :is-declined="isDeclined"
    :is-waiting="isWaiting"
  />
</template>

<script setup lang="ts">
import type { AttendeeDto, InviteeDto, UserDto } from '@/core/data/user/user.interface';
import { gambits } from '@/core/gambits';
import GamAttendeeRow from '@/views/components/gam-player/GamAttendeeRow.vue';
import { computed, onMounted, ref, watch } from 'vue';

interface ChallengedPlayerProps {
  id: string;
  player?: InviteeDto | null;
  isOrganizer?: boolean;
  isWaiting?: boolean;
  isConfirmed?: boolean;
  isDeclined?: boolean;
}

const props = defineProps<ChallengedPlayerProps>();

const playerDetails = ref<UserDto | null>(null);

const rowPlayer = computed((): AttendeeDto | null => {
  if (props.player) return props.player as AttendeeDto;
  return playerDetails.value;
});

const getPlayerDetail = async () => {
  if (props.player) return;

  const result = await gambits.userService.getUser(props.id);

  if (!result.data) return null;

  playerDetails.value = result.data;
};

watch(
  () => props.id,
  () => {
    getPlayerDetail();
  },
);

onMounted(async () => {
  getPlayerDetail();
});
</script>
